export default "__VITE_ASSET__9ea1e2f7__"